import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  class: "flex px-3 shadow-md whitespace-nowrap bg-primary border-primary text-white",
  style: {"border-radius":"2rem"}
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["title"]
const _hoisted_4 = ["title"]
const _hoisted_5 = ["title"]
const _hoisted_6 = ["title"]
const _hoisted_7 = { key: 5 }
const _hoisted_8 = {
  key: 6,
  style: {"margin-top":"3px","margin-bottom":"1px"}
}
const _hoisted_9 = ["title"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons text-2xl",
  style: {"color":"#f7c327"}
}, " bookmark ", -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["title"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons text-2xl text-white dark:text-dark-text" }, " bookmark_border ", -1)
const _hoisted_14 = [
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isLogin)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2))
      : (
        _ctx.problemDescriptionPresenter.problemDescription.value.isSolved || _ctx.nested.judgeStatus.value == 'ACCEPTED'
      )
        ? (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: "material-icons text-2xl my-auto notranslate text-white dark:text-dark-text",
            title: _ctx.$t('message.isSolved')
          }, " check_circle ", 8, _hoisted_3))
        : (_openBlock(), _createElementBlock("span", {
            key: 2,
            class: "material-icons text-2xl my-auto rounded-full text-white dark:text-dark-text",
            title: _ctx.$t('message.isNotSolved')
          }, " remove_circle_outline ", 8, _hoisted_4)),
    (_ctx.arenaPresenter.arenaId.value != '')
      ? (_openBlock(), _createElementBlock("span", {
          key: 3,
          class: "text-xl inline-block px-3 my-auto whitespace-no-wrap text-white dark:text-dark-text",
          style: {"border-radius":"1rem"},
          title: _ctx.$t('message.problemId')
        }, _toDisplayString(_ctx.arenaPresenter.arenaId.value) + " - " + _toDisplayString(_ctx.arenaPresenter.arenaProblemId.value) + " - " + _toDisplayString(_ctx.problemId), 9, _hoisted_5))
      : (_openBlock(), _createElementBlock("span", {
          key: 4,
          class: _normalizeClass(["text-xl inline-block px-3 my-auto whitespace-no-wrap text-white dark:text-dark-text", {
        'py-1': !_ctx.isLogin
      }]),
          style: {"border-radius":"1rem"},
          title: _ctx.$t('message.problemId')
        }, _toDisplayString(_ctx.problemId), 11, _hoisted_6)),
    (!_ctx.isLogin)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (_ctx.nested.isBookmark.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "focus:outline-none material-icons",
                title: _ctx.$t('message.bookmarked'),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.deleteBookmark()))
              }, _hoisted_11, 8, _hoisted_9))
            : (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "focus:outline-none material-icons",
                title: _ctx.$t('message.addBookmark'),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.postBookmark()))
              }, _hoisted_14, 8, _hoisted_12))
        ]))
  ]))
}